import { render, staticRenderFns } from "./LastPage2025.vue?vue&type=template&id=694a2189&scoped=true"
import script from "./LastPage2025.vue?vue&type=script&lang=js"
export * from "./LastPage2025.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694a2189",
  null
  
)

export default component.exports